import { AjaxError } from 'rxjs/ajax';
import { tap } from 'rxjs/operators';
import { pipe } from 'rxjs';
export const getFCIHeader = (xhr) => {
    const fciStatus = xhr.getResponseHeader('fid-ws-http-status');
    if (!fciStatus) {
        return null;
    }
    else {
        // if not parsable act like its not there
        return parseInt(fciStatus, 10) || null;
    }
};
export const ExperienceApiHeaderStatusValidity = () => {
    return pipe(tap((ajaxResponse) => {
        const fciStatus = getFCIHeader(ajaxResponse.xhr);
        if (fciStatus && (+fciStatus < 200 || +fciStatus > 299)) {
            throw new AjaxError('fid-ws-http-status:error', ajaxResponse.xhr, ajaxResponse.request);
        }
    }));
};
//# sourceMappingURL=experience-api-header-status-validity.operator.js.map